import React, {Component } from 'react';
import { Notifier } from '@airbrake/browser';
import {
  Col,
  Grid,
  Message,
  Row,
} from 'rsuite';
import config from '../../config';
import './ErrorBoundary.less';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.airbrake = new Notifier({
      projectId: config.projectId,
      projectKey: config.projectKey
    });
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });

    // Send error to New Relic
    if (window.newrelic) {
      window.newrelic.noticeError(error);
    }

    // Send error to Airbrake
    this.airbrake.notify({
      error: error,
      params: {info: info}
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Grid fluid className="vp-campaigns-container">
        <Row>
          <Col xs={24} sm={24} md={4} lg={4} />
          <Col xs={24} sm={12} md={16} lg={16}>
            <div className="vp-error-boundary">
              <Message
                showIcon
                type="error"
                title="Error"
                description="An error occurred. Please refresh the page and try again."
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={4} lg={4} />
        </Row>
      </Grid>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.js